// assets/cart-upgrade.js
const money = (cents) => {
  try {
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: Shopify.currency.active });
  } catch {
    return `$${(cents / 100).toFixed(2)}`;
  }
};

async function addVariant(variantId, qty, properties) {
  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: Number(qty) || 1,
      properties: properties || {}
    })
  });

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "Failed to add upgraded variant");
  }
  return res.json();
}

async function removeLineItemByKey(lineKey) {
  // Shopify supports removing by line item key using change.js with { id: key, quantity: 0 }
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  });

  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || "Failed to remove old line item");
  }
  return res.json();
}

function safeParseProperties(str) {
  if (!str) return {};
  try {
    // In Liquid we passed escaped JSON string
    return JSON.parse(str);
  } catch {
    return {};
  }
}

function isCartPage() {
  return window.location.pathname === "/cart" || document.body.className.includes("template-cart");
}

function refreshUI() {
  // Cart page: simplest + most reliable
  if (isCartPage()) {
    window.location.reload();
    return;
  }

  // Drawer / AJAX contexts:
  // 1) Trigger common refresh events
  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
  document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true }));

  // 2) Fallback: reload the page if drawer doesn’t update after a moment
  setTimeout(() => {
    // If the button is still on page and says upgrading, force a reload
    // (safe fallback, avoids “stuck” state)
    if (!isCartPage()) window.location.reload();
  }, 900);
}

document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".cart-upgrade__btn");
  if (!btn) return;

  e.preventDefault();

  const nextVariantId = btn.getAttribute("data-upgrade-to");
  const lineKey = btn.getAttribute("data-line-key");
  const qty = btn.getAttribute("data-qty") || "1";
  const propsStr = btn.getAttribute("data-properties");
  const properties = safeParseProperties(propsStr);

  const status = btn.closest(".cart-upgrade")?.querySelector(".cart-upgrade__status");

  // UI state
  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = "Upgrading…";
  if (status) status.textContent = "";

  try {
    // 1) Add upgraded variant
    await addVariant(nextVariantId, qty, properties);

    // 2) Remove old line item
    await removeLineItemByKey(lineKey);

    // 3) Refresh UI
    refreshUI();
  } catch (err) {
    console.error(err);
    btn.disabled = false;
    btn.textContent = originalText;
    if (status) status.textContent = "Couldn’t upgrade. Please try again.";
  }
});